var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-12 overflow-y-auto body-wrapper" },
    [
      _c(
        "div",
        {
          staticClass:
            "mx-4 lg:mx-64 pb-16 pt-20 text-center lg:pt-32 bg-center",
        },
        [
          _c(
            "h1",
            {
              staticClass:
                "font-display text-3xl xl:text-4xl 2xl:text-5xl font-bold tracking-tight text-slate-900 sm:text-5xl",
            },
            [
              _vm._v(" 中小非标机械厂 "),
              _c(
                "span",
                { staticClass: "relative whitespace-nowrap text-blue-600" },
                [
                  _c(
                    "svg",
                    {
                      staticClass:
                        "absolute left-0 top-2/3 h-[0.58em] w-full fill-blue-300/70",
                      attrs: {
                        "aria-hidden": "true",
                        viewBox: "0 0 418 42",
                        preserveAspectRatio: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M203.371.916c-26.013-2.078-76.686 1.963-124.73 9.946L67.3 12.749C35.421 18.062 18.2 21.766 6.004 25.934 1.244 27.561.828 27.778.874 28.61c.07 1.214.828 1.121 9.595-1.176 9.072-2.377 17.15-3.92 39.246-7.496C123.565 7.986 157.869 4.492 195.942 5.046c7.461.108 19.25 1.696 19.17 2.582-.107 1.183-7.874 4.31-25.75 10.366-21.992 7.45-35.43 12.534-36.701 13.884-2.173 2.308-.202 4.407 4.442 4.734 2.654.187 3.263.157 15.593-.78 35.401-2.686 57.944-3.488 88.365-3.143 46.327.526 75.721 2.23 130.788 7.584 19.787 1.924 20.814 1.98 24.557 1.332l.066-.011c1.201-.203 1.53-1.825.399-2.335-2.911-1.31-4.893-1.604-22.048-3.261-57.509-5.556-87.871-7.36-132.059-7.842-23.239-.254-33.617-.116-50.627.674-11.629.54-42.371 2.494-46.696 2.967-2.359.259 8.133-3.625 26.504-9.81 23.239-7.825 27.934-10.149 28.304-14.005.417-4.348-3.529-6-16.878-7.066Z",
                        },
                      }),
                    ]
                  ),
                  _c("span", { staticClass: "relative" }, [_vm._v("ERP&MES")]),
                ]
              ),
              _c("span", [_vm._v(" 一体化管理系统")]),
              _c("span", [_vm._v(" (支持非标定制)")]),
            ]
          ),
          _vm._m(0),
          _vm._m(1),
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "px-4 lg:px-0 py-8 text-center lg:py-16 bg-[#fafafa] border-y",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "font-display tracking-tight text-base lg:text-2xl mx-4 font-semibold",
            },
            [_vm._v(" 小投入，高收益：为工厂创造可量化价值 ")]
          ),
          _vm._m(2),
          _c(
            "div",
            {
              staticClass:
                "flex flex-col lg:hidden px-2 xl:px-24 2xl:px-64 mt-6",
            },
            [
              _c("img", {
                staticClass:
                  "h-[260px] rounded-xl border border-solid border-[#9fc6ff]",
                attrs: {
                  src: require("@/assets/imgs/home_products/advantage.png"),
                },
              }),
              _c("img", {
                staticClass:
                  "h-[320px] mt-4 rounded-xl border border-solid border-[#9fc6ff]",
                attrs: {
                  src: require("@/assets/imgs/home_products/features.png"),
                },
              }),
              _c(
                "div",
                {
                  staticClass:
                    "rounded-xl mt-4 p-2 border border-solid border-[#9fc6ff] bg-[#f4faff]",
                },
                [
                  _c("div", { staticClass: "text-base lg:text-xl" }, [
                    _vm._v("帮助客户实现"),
                  ]),
                  _c(
                    "a-row",
                    { staticClass: "px-2 mt-6" },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        _vm._l(_vm.profits.ups, function (item) {
                          return _c(
                            "a-card",
                            {
                              key: item.label,
                              staticClass: "mb-2",
                              attrs: { bodyStyle: { padding: "12px" } },
                            },
                            [
                              _c("a-statistic", {
                                attrs: {
                                  title: item.label,
                                  value: item.value,
                                  suffix: "%",
                                  "value-style": { color: "#3f8600" },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "prefix",
                                      fn: function () {
                                        return [
                                          _c("a-icon", {
                                            staticStyle: {
                                              "vertical-align": "0",
                                            },
                                            attrs: { type: "arrow-up" },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        _vm._l(_vm.profits.downs, function (item) {
                          return _c(
                            "a-card",
                            {
                              key: item.label,
                              staticClass: "mb-2 ml-2",
                              attrs: { bodyStyle: { padding: "12px" } },
                            },
                            [
                              _c("a-statistic", {
                                attrs: {
                                  title: item.label,
                                  value: item.value,
                                  suffix: "%",
                                  "value-style": {
                                    color: "#1890ff",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "prefix",
                                      fn: function () {
                                        return [
                                          _c("a-icon", {
                                            staticStyle: {
                                              "vertical-align": "0",
                                            },
                                            attrs: { type: "arrow-down" },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "px-4 lg:px-0 pt-8 text-center lg:pt-12 border-b" },
        [
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "font-display tracking-tight text-base lg:text-2xl mx-4 font-semibold",
                },
                [_vm._v(" 帮助每个中小型非标机械厂，实现更低成本的速度出货 ")]
              ),
              _c(
                "a-tabs",
                {
                  staticClass: "pt-2 lg:pt-4 text-lg",
                  attrs: {
                    "default-active-key": "1",
                    size: "large",
                    animated: false,
                  },
                },
                [
                  _c(
                    "a-tab-pane",
                    {
                      key: "1",
                      scopedSlots: _vm._u([
                        {
                          key: "tab",
                          fn: function () {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "flex items-center text-sm lg:text-lg",
                                },
                                [
                                  _c("a-icon", { attrs: { type: "project" } }),
                                  _vm._v(" 生产透明化 "),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col lg:flex-row justify-center items-center py-8 lg:py-16",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-col justify-start" },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-lg tracking-wide sm:text-xl md:text-3xl font-semibold",
                                },
                                [_vm._v("生产透明化")]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "flex items-center text-sm tracking-wide lg:text-xl mt-3 lg:mt-6",
                                },
                                [
                                  _c("a-icon", {
                                    staticClass:
                                      "mr-2 text-base text-green-500",
                                    attrs: { type: "check" },
                                  }),
                                  _vm._v(" 生产进度管理 "),
                                ],
                                1
                              ),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "flex items-center text-sm tracking-wide lg:text-xl pt-2",
                                },
                                [
                                  _c("a-icon", {
                                    staticClass:
                                      "mr-2 text-base text-green-500",
                                    attrs: { type: "check" },
                                  }),
                                  _vm._v(" 生产工艺管理 "),
                                ],
                                1
                              ),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "flex items-center text-sm tracking-wide lg:text-xl pt-2",
                                },
                                [
                                  _c("a-icon", {
                                    staticClass:
                                      "mr-2 text-base text-green-500",
                                    attrs: { type: "check" },
                                  }),
                                  _vm._v(" 生产质量管理 "),
                                ],
                                1
                              ),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "flex items-center text-sm tracking-wide lg:text-xl pt-2 text-left",
                                },
                                [
                                  _c("a-icon", {
                                    staticClass:
                                      "mr-2 text-base text-green-500",
                                    attrs: { type: "check" },
                                  }),
                                  _vm._v(" 库存管理 "),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "a-carousel",
                            {
                              staticClass:
                                "ml-3 lg:ml-36 w-4/5 lg:w-[760px] rounded-xl mt-2 lg:mt-0",
                              attrs: { dots: false, arrows: "", autoplay: "" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "custom-slick-arrow",
                                  staticStyle: { left: "10px", "z-index": "1" },
                                  attrs: { slot: "prevArrow" },
                                  slot: "prevArrow",
                                },
                                [
                                  _c("a-icon", {
                                    attrs: { type: "left-circle" },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "custom-slick-arrow",
                                  staticStyle: { right: "10px" },
                                  attrs: { slot: "nextArrow" },
                                  slot: "nextArrow",
                                },
                                [
                                  _c("a-icon", {
                                    attrs: { type: "right-circle" },
                                  }),
                                ],
                                1
                              ),
                              _c("img", {
                                staticClass:
                                  "lg:w-[760px] h-[200px] lg:h-[405px] rounded-xl border border-solid border-[#9fc6ff]",
                                attrs: {
                                  src: require("@/assets/imgs/home_products/process.png"),
                                },
                              }),
                              _c("img", {
                                staticClass:
                                  "lg:w-[760px] h-[200px] lg:h-[405px] rounded-xl border border-solid border-[#9fc6ff]",
                                attrs: {
                                  src: require("@/assets/imgs/home_products/tech.png"),
                                },
                              }),
                              _c("img", {
                                staticClass:
                                  "lg:w-[760px] h-[200px] lg:h-[405px] rounded-xl border border-solid border-[#9fc6ff]",
                                attrs: {
                                  src: require("@/assets/imgs/home_products/quality.png"),
                                },
                              }),
                              _c("img", {
                                staticClass:
                                  "lg:w-[760px] h-[200px] lg:h-[405px] rounded-xl border border-solid border-[#9fc6ff]",
                                attrs: {
                                  src: require("@/assets/imgs/home_products/total.png"),
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "a-tab-pane",
                    {
                      key: "2",
                      scopedSlots: _vm._u([
                        {
                          key: "tab",
                          fn: function () {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "flex items-center text-sm lg:text-lg",
                                },
                                [
                                  _c("a-icon", {
                                    attrs: { type: "area-chart" },
                                  }),
                                  _vm._v(" 智能排产 "),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col lg:flex-row justify-center items-center py-8 lg:py-16",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-col justify-start" },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-lg tracking-wide sm:text-xl md:text-3xl font-semibold",
                                },
                                [_vm._v("智能排产")]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "flex items-center text-sm tracking-wide lg:text-xl mt-3 lg:mt-6",
                                },
                                [
                                  _c("a-icon", {
                                    staticClass:
                                      "mr-2 text-base text-green-500",
                                    attrs: { type: "check" },
                                  }),
                                  _vm._v(" 瓶颈资源管理 "),
                                ],
                                1
                              ),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "flex items-center text-sm tracking-wide lg:text-xl pt-2",
                                },
                                [
                                  _c("a-icon", {
                                    staticClass:
                                      "mr-2 text-base text-green-500",
                                    attrs: { type: "check" },
                                  }),
                                  _vm._v(" 辅助优化排产 "),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "a-carousel",
                            {
                              staticClass:
                                "ml-3 lg:ml-36 w-4/5 lg:w-[760px] rounded-xl mt-2 lg:mt-0",
                              attrs: { dots: false, arrows: "", autoplay: "" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "custom-slick-arrow",
                                  staticStyle: { left: "10px", "z-index": "1" },
                                  attrs: { slot: "prevArrow" },
                                  slot: "prevArrow",
                                },
                                [
                                  _c("a-icon", {
                                    attrs: { type: "left-circle" },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "custom-slick-arrow",
                                  staticStyle: { right: "10px" },
                                  attrs: { slot: "nextArrow" },
                                  slot: "nextArrow",
                                },
                                [
                                  _c("a-icon", {
                                    attrs: { type: "right-circle" },
                                  }),
                                ],
                                1
                              ),
                              _c("img", {
                                staticClass:
                                  "lg:w-[760px] h-[200px] lg:h-[405px] rounded-xl border border-solid border-[#9fc6ff]",
                                attrs: {
                                  src: require("@/assets/imgs/home_products/stay.png"),
                                },
                              }),
                              _c("img", {
                                staticClass:
                                  "lg:w-[760px] h-[200px] lg:h-[405px] rounded-xl border border-solid border-[#9fc6ff]",
                                attrs: {
                                  src: require("@/assets/imgs/home_products/sort.png"),
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "a-tab-pane",
                    {
                      key: "3",
                      scopedSlots: _vm._u([
                        {
                          key: "tab",
                          fn: function () {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "flex items-center text-sm lg:text-lg",
                                },
                                [
                                  _c("a-icon", {
                                    attrs: { type: "cloud-server" },
                                  }),
                                  _vm._v(" 效能洞察 "),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col lg:flex-row justify-center items-center py-8 lg:py-16",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-col justify-start" },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-lg tracking-wide sm:text-xl md:text-3xl font-semibold",
                                },
                                [_vm._v("效能洞察")]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "flex items-center tracking-wide text-sm lg:text-xl mt-3 lg:mt-6",
                                },
                                [
                                  _c("a-icon", {
                                    staticClass:
                                      "mr-2 text-base text-green-500",
                                    attrs: { type: "check" },
                                  }),
                                  _vm._v(" 有效产出分析 "),
                                ],
                                1
                              ),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "flex items-center text-sm tracking-wide lg:text-xl pt-2",
                                },
                                [
                                  _c("a-icon", {
                                    staticClass:
                                      "mr-2 text-base text-green-500",
                                    attrs: { type: "check" },
                                  }),
                                  _vm._v(" 库存水平分析 "),
                                ],
                                1
                              ),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "flex items-center text-sm tracking-wide lg:text-xl pt-2",
                                },
                                [
                                  _c("a-icon", {
                                    staticClass:
                                      "mr-2 text-base text-green-500",
                                    attrs: { type: "check" },
                                  }),
                                  _vm._v(" 营运费用分析 "),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "a-carousel",
                            {
                              staticClass:
                                "ml-3 lg:ml-36 w-4/5 lg:w-[760px] rounded-xl mt-2 lg:mt-0",
                              attrs: { dots: false, arrows: "", autoplay: "" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "custom-slick-arrow",
                                  staticStyle: { left: "10px", "z-index": "1" },
                                  attrs: { slot: "prevArrow" },
                                  slot: "prevArrow",
                                },
                                [
                                  _c("a-icon", {
                                    attrs: { type: "left-circle" },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "custom-slick-arrow",
                                  staticStyle: { right: "10px" },
                                  attrs: { slot: "nextArrow" },
                                  slot: "nextArrow",
                                },
                                [
                                  _c("a-icon", {
                                    attrs: { type: "right-circle" },
                                  }),
                                ],
                                1
                              ),
                              _c("img", {
                                staticClass:
                                  "lg:w-[760px] h-[200px] lg:h-[405px] rounded-xl border border-solid border-[#9fc6ff]",
                                attrs: {
                                  src: require("@/assets/imgs/home_products/analyze.png"),
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticClass: "flex flex-col justify-center mt-10" }, [
        _c(
          "p",
          {
            staticClass:
              "text-lg text-center tracking-wide sm:text-xl md:text-2xl font-semibold",
          },
          [_vm._v("高效落地流程")]
        ),
        _c(
          "div",
          {
            staticClass:
              "flex items-center justify-start lg:justify-center space-x-8 mt-6 px-8 overflow-auto",
          },
          _vm._l(_vm.steps, function (step, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass:
                  "relative border border-dashed border-[#9fc6ff] p-3 rounded-md",
              },
              [
                _c(
                  "div",
                  { staticClass: "flex flex-col items-center" },
                  [
                    _c(
                      "a-tag",
                      {
                        staticClass: "mb-2 text-sm lg:text-base",
                        attrs: { color: "blue" },
                      },
                      [_vm._v(_vm._s(step.label))]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "relative w-6 h-6 lg:w-8 lg:h-8 bg-[#6cb7ff] rounded-full text-white text-sm lg:text-base font-semibold flex items-center justify-center z-10",
                      },
                      [_vm._v(" " + _vm._s(index + 1) + " ")]
                    ),
                  ],
                  1
                ),
                index !== _vm.steps.length - 1
                  ? _c("div", {
                      staticClass:
                        "absolute left-[100%] top-1/2 border-t-2 border-[#9fc6ff] w-8",
                    })
                  : _vm._e(),
              ]
            )
          }),
          0
        ),
      ]),
      _c("home-page-to-contact"),
      _c("home-page-contact"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h3",
      { staticClass: "mt-12 text-sm lg:text-xl tracking-wide text-slate-700" },
      [
        _vm._v(" 支持产品从"),
        _c("strong", [_vm._v("下单生产")]),
        _vm._v("到"),
        _c("strong", [_vm._v("出货对账")]),
        _vm._v("全流程"),
        _c("strong", [_vm._v("一体化数字管理")]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-10 flex justify-center gap-x-6" }, [
      _c("div", { staticClass: "text-white" }, [
        _c(
          "a",
          {
            staticClass:
              "inline-flex items-center justify-center rounded-full py-2 lg:py-3 px-4 lg:px-8 text-base lg:text-lg font-semibold tracking-wide focus:outline-none bg-blue-600 hover:bg-blue-500",
            attrs: {
              variant: "solid",
              color: "slate",
              href: "/apply",
              target: "_blank",
            },
          },
          [_vm._v(" 申请演示 ")]
        ),
      ]),
      _c("div", { staticClass: "text-blue-600 hover:text-blue-500" }, [
        _c(
          "a",
          {
            staticClass:
              "inline-flex items-center justify-center rounded-full py-2 lg:py-3 px-4 lg:px-8 text-base lg:text-lg font-semibold tracking-wide focus:outline-none border border-blue-600",
            attrs: {
              variant: "solid",
              color: "slate",
              href: "/apply",
              target: "_blank",
            },
          },
          [_vm._v(" 获取方案 ")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hidden lg:flex justify-center mt-6" }, [
      _c("div", { staticClass: "w-[500px]" }, [
        _c("img", {
          staticClass:
            "h-[420px] rounded-xl border border-solid border-[#9fc6ff]",
          attrs: { src: require("@/assets/imgs/home_products/values.png") },
        }),
      ]),
      _c("div", { staticClass: "w-[600px] ml-4" }, [
        _c("img", {
          staticClass:
            "h-[420px] rounded-xl border border-solid border-[#9fc6ff]",
          attrs: { src: require("@/assets/imgs/home_products/advantage.png") },
        }),
      ]),
      _c("div", { staticClass: "w-[400px] ml-4" }, [
        _c("img", {
          staticClass:
            "h-[420px] rounded-xl border border-solid border-[#9fc6ff]",
          attrs: { src: require("@/assets/imgs/home_products/features.png") },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }